function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#7E7E7E",
  d: "M113.2,89.9c1.1-1.5,2-3.2,3.3-4.4c26.5-26.5,53-53,79.5-79.5c6-6,13.1-7.5,19.5-4.3 c8.9,4.5,11.4,15.8,5.2,23.9c-1.1,1.4-2.5,2.7-3.8,4c-30.3,30.2-60.6,60.5-90.9,90.7c-9.9,9.9-17.8,9.9-27.7,0 c-30.5-30.5-61.1-61-91.6-91.4c-5.2-5.2-8.2-10.9-5.4-18.4C5,0,16.9-3.3,25.6,3.7c1.6,1.2,3,2.7,4.4,4.1 c25.9,25.9,51.8,51.8,77.7,77.8c1.3,1.3,2.2,3,3.2,4.4C111.7,90,112.4,89.9,113.2,89.9z"
});

var SvgIconCaretDown = function SvgIconCaretDown(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "224.1px",
    height: "127.7px",
    viewBox: "0 0 224.1 127.7",
    enableBackground: "new 0 0 224.1 127.7",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCaretDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-caret-down.56d49640.svg";
export { ForwardRef as ReactComponent };